import React from 'react';
import PropTypes from 'prop-types';

import { StyledDialogActions } from './styles';

export const VpDialogActions = ({ fullWidth = false, children }) => {
  return <StyledDialogActions fullWidth={fullWidth}>{children}</StyledDialogActions>;
};

VpDialogActions.propTypes = {
  fullWidth: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};

export default VpDialogActions;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpDialogActions/VpDialogActions.jsx